module.exports = __webpack_public_path__ + "img/device_cb_terminal.bfe7fa54.png";